import { OnInit, Directive } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FacetGroup } from '@finder/features/list/components/filters/classes/facet-group.class';
import { FilterGroup } from '@finder/features/list/components/filters/classes/filter-group.class';
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';

@Directive()
export class AllFiltersBase implements OnInit {

    _allFilters: FilterGroup[] = [];
    destroy$ = new Subject<void>();

    constructor(
        protected filterEmitterService: FilterEmitterService
    ) {}

    ngOnInit() {
        this.filterEmitterService.watchFilter()
            .pipe(takeUntil(this.destroy$))
            .subscribe((facet: Facet) => this.setFilterGroupState(facet));
    }

    onCheck(event: any, facet: Facet) {
        /**
         * Avoid to trigger a filtering process
         * if the selected value is equal to the current value
         */
        if (facet.value === event.detail.value) {
            return;
        }
        facet.value = event.detail.value;
        this.filterEmitterService.emitFilter(facet);
    }

    setFilterGroupState(facet: Facet) {
        this._allFilters.forEach((filter: FilterGroup) => this.setFacetGroupState(filter.facetGroups, facet));
    }

    setFacetGroupState(facetGroups: FacetGroup[], facet: Facet) {
        facetGroups.forEach((facetGroup) => {
            this.setFacetState(facetGroup.facets, facet);
        });
    }

    setFacetState(facetList: Facet[], facet: Facet) {
        const myFacet = facetList.find(f => f.equal(facet));
        if (myFacet) {
            myFacet.value = facet.value;
        }
    }
}
